import React from 'react';
import V3BasePage from '../pages/V3BasePage';

export default function App() {
  return <V3BasePage />;
}
